import { i18n } from '@shared/i18n';
import { filter, get } from 'lodash';

const tabsConfig = {
  locations: {
    type: 'locations',
    label: i18n('entities.location.label'),
    routerPush: {
      params: {
        tabName: 'locations'
      }
    },
    buttonLink: '/subproperty/settings/program/location/new',
    buttonCode: 'entities.location.new.title',
  },
  categories: {
    type: 'categories',
    label: i18n('entities.category.ageCategories'),
    routerPush: {
      params: {
        tabName: 'categories'
      }
    },
    buttonLink: '/subproperty/settings/program/category/new',
    buttonCode: 'entities.category.new.title',
  },
};

import { getSubpropertyRequirementStepsByPropertyType } from '@shared/factories/enums-factory';

export default {
  namespaced: true,

  state: {
    tabIndex: 0
  },

  getters: {
    tabs: (state, getters, rootState) => filter(tabsConfig, ({ type }) => {
      const propertyType = get(rootState, 'auth.manage.currentManage.property.type', null);
      return getSubpropertyRequirementStepsByPropertyType(propertyType).includes(type) ;
    }),
    tabIndex: state => state.tabIndex
  },

  mutations: {
    SET_TAB_INDEX(state, payload) {
      state.tabIndex = payload;
    }
  },

  actions: {
    doResetTabs({ commit } ) {
      commit('SET_TAB_INDEX', 0);
    },
    setTabIndex({ commit }, tabIndex ) {
      commit('SET_TAB_INDEX', tabIndex);
    }
  },
};
